<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="row mt-1">
    <div class="col-lg-4 offset-lg-4">
        <div class="card text-white bg-secondary mb-3" style="max-width: 25rem;">
            <div class="card-header text-center">{{ operacion }} Producto</div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="addProduct()">
                    <input formControlName="name" type="text" class="form-control" placeholder="Ingrese nombre">
                    <span *ngIf="form.get('name')?.hasError('required') && form.get('name')?.touched">
                        El campo nombre es <strong>requerido</strong>
                    </span>
                    <input formControlName="description" type="text" class="form-control mt-2" placeholder="Ingrese descripcion">
                    <span *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched">
                        El campo descripcion es <strong>requerido</strong>
                    </span>
                    <input formControlName="price" type="number" class="form-control mt-2" placeholder="Ingrese precio">
                    <span *ngIf="form.get('price')?.hasError('required') && form.get('price')?.touched">
                        El campo price es <strong>requerido</strong>
                    </span>
                    <input formControlName="stock" type="number" class="form-control mt-2" placeholder="Ingrese stock">
                    <span *ngIf="form.get('stock')?.hasError('required') && form.get('stock')?.touched">
                        El campo stock es <strong>requerido</strong>
                    </span>
                    <div class="row mt-2 text-center">
                        <div class="col-lg-6">
                            <button routerLink="/dashboard" type="button" class="btn btn-secondary">Volver</button>
                        </div>
                        <div class="col-lg-6">
                            <button  [disabled]="form.invalid" type="submit" class="btn btn-primary">Aceptar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>